module.exports = __webpack_public_path__ + "static/media/01A.d84e1b8a.png";